import { Indicator, Toast } from 'mint-ui'
// http访问类
// debugger
let serviceIp = process.env.BASE_API || '//' + window.location.hostname + ':8080'
let wxserviceIp = process.env.WX_API || '//' + window.location.hostname + ':8080'

// debugger
class BaseHttp {
  service = ''
  serviceIp = ''
  constructor (serviceIp, service = '') {
    this.serviceIp = serviceIp
    this.service = service
  }
  getFunc () {
    let thiz = this
    let func = function (
      vm,
      url,
      method = 'GET',
      data = {},
      headers = {},
      moduleName = ''
    ) {
      if (url.indexOf('http') < 0 || url.indexOf('=http') > 0) { // 考虑到会把链接当成参数的情况，加入第二种情况
        url = thiz.serviceIp + thiz.service + moduleName + url
      }
      let promise = new Promise((resolve, reject) => {
        let pro = null
        if (method === 'POST') {
          pro = vm.$http.post(url, data, headers)
        } else if (method === 'GET') {
          pro = vm.$http.get(url, data, headers)
        } else if (method === 'PUT') {
          pro = vm.$http.put(url, data, headers)
        } else if (method === 'DELETE') {
          pro = vm.$http.delete(url, data, headers)
        }
        pro.then(
          response => {
            // Indicator.close();
            this.disClick = false;
            if (response.data.success) {
              resolve(response)

            } else {
              // if (response.data.resultCode != '10002' && response.data.message){
              //     let message = response.data.message
              //     if(message!='已经获取过机会了'){
              //       this.$toast(message)
              //     }
              // }
              reject(response)
            }
          },
          error => {
            // Indicator.close();
            // let message = '请求出错'
            // console.log(error)
            // setTimeout(function(){
            //   Toast({
            //     message: message,
            //     position: 'middle'
            //   });
            // },1000)
            reject(error)
          }
        )
      })
      return promise
    }
    return func
  }
}

function plugin (Vue) {
  if (plugin.installed) {
    return
  }
  Object.defineProperties(Vue.prototype, {
    $tupHttp: { // activity
      get () {
        return new BaseHttp(serviceIp, '/').getFunc()
      }
    },
    $wxHttp: { // wechat
      get () {
        return new BaseHttp(wxserviceIp, '/').getFunc()
      }
    },
    $epmsEnv: {
      get () {
        return window.epmsEnv
      }
    }
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin)
}

export default plugin



// WEBPACK FOOTER //
// ./src/util/service.js